import { ArrowRight, Circle, ListChecks, LucideIcon } from "lucide-react";

import { Badge } from "@/components/ui/badge";

const ChoicesSection = ({
  choices = [],
  title = "",
  defaultText = "",
  icon: Icon = ListChecks,
  variant = "default",
}: {
  choices: string[];
  title: string;
  defaultText: string;
  icon: LucideIcon;
  variant?: "default" | "rounded" | "arrow";
}) => {
  const renderIcon = (choice: string) => {
    if (variant === "rounded") {
      return <Badge variant="outline">{choice}</Badge>;
    } else if (variant === "arrow") {
      return (
        <div className="flex items-center">
          <ArrowRight className="mr-2 size-5 text-vincer-600" />
          <span>{choice}</span>
        </div>
      );
    } else {
      return (
        <div className="flex items-center">
          <Circle className={`mr-3 size-1 fill-current text-gray-600`} />
          <span>{choice}</span>
        </div>
      );
    }
  };

  return (
    <div
      className={
        variant === "rounded"
          ? ""
          : `rounded-lg border border-gray-100 bg-gray-50 p-4`
      }
    >
      <div
        className={`flex items-center ${variant === "rounded" ? "mb-4" : "mb-2"}`}
      >
        <Icon className={`mr-2 size-4 text-gray-600`} />
        <h3 className={`font-medium text-gray-900`}>{title}</h3>
      </div>
      {choices.length > 0 ? (
        <ul
          className={
            variant === "rounded"
              ? "flex flex-wrap gap-2"
              : "divide-y divide-gray-200"
          }
        >
          {choices.map((choice, index) => (
            <li
              key={`choice-${title}-${index}`}
              className={
                variant === "rounded"
                  ? ""
                  : `text-md flex items-center px-3 py-2`
              }
            >
              {renderIcon(choice, index)}
            </li>
          ))}
        </ul>
      ) : (
        <p className={`text-sm text-gray-800`}>{defaultText}</p>
      )}
    </div>
  );
};

export default ChoicesSection;
